module.exports = __webpack_public_path__ + "static/party_kit_img@2x-2f1ad58418d68a2a0cf7c317517e41ed.jpg";